export const createLazyAction = (
  element,
  callback,
  hideLoaderSelector = '',
  intersectionOptions = {},
) => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(async (entry) => {
      if (entry.target === element && entry.isIntersecting) {
        let loaderEl;
        if (hideLoaderSelector) {
          loaderEl = element.querySelector(hideLoaderSelector);
        }
        loaderEl?.classList?.remove('hidden');
        callback && await callback();
        loaderEl?.classList?.add('hidden');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.225,
    rootMargin: '15px',
    ...intersectionOptions,
  });
  return () => {
    if (!element) return;
    observer.observe(element);
  };
};